import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import getObjectsLocationsAction from "../actions/get-objects-locations.action";
import { mapObjectsToMarkers } from "domain/objects/entities/mappers/map-objects-to-markers.mapper";
import { ObjectsState } from "domain/objects/entities/interfaces/object-state.interface";

const getObjectsLocationsCases = (
  builder: ActionReducerMapBuilder<ObjectsState>
) => {
  builder.addCase(getObjectsLocationsAction.pending, (state) => {
    state.isLoadingObjects = true;
    state.markers = [];
    state.objects = [];
  });

  builder.addCase(getObjectsLocationsAction.fulfilled, (state, action) => {
    if (action.payload && action.payload.length > 0) {
      state.isLoadingObjects = true;
      state.objects = action.payload;
      state.markers = mapObjectsToMarkers(action.payload, {
        statusLookup: state.objectStatusesByUniqueId,
        showInactiveObjects: state.showInactiveObjects
      });
    }
    state.isLoadingObjects = false;
  });

  builder.addCase(getObjectsLocationsAction.rejected, (state) => {
    state.isLoadingObjects = false;
  });
};

export default getObjectsLocationsCases;
